import { useEffect, useState } from "react";
import { StyleSheet, View, ViewStyle } from "react-native";

// Components
import SearchBar from "../SearchBar";
import Divider from "../Divider";
import Entity from "./Entity";

// Data
import { nanoid } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux";
import { selectEntity, setEntity } from "../../../redux/mainSlice";

// Utils
import { Colors } from "../../../styles";
import { Data } from "../../../types";

interface Entity {
  id: string;
  entity: Data.Entity;
}

const entities: Entity[] = [
  {
    id: nanoid(),
    entity: "public",
  },
  {
    id: nanoid(),
    entity: "friends",
  },
  {
    id: nanoid(),
    entity: "amazon",
  },
  {
    id: nanoid(),
    entity: "instagram",
  },
  {
    id: nanoid(),
    entity: "facebook",
  },
  {
    id: nanoid(),
    entity: "spotify",
  },
  {
    id: nanoid(),
    entity: "reddit",
  },
  {
    id: nanoid(),
    entity: "google",
  },
  {
    id: nanoid(),
    entity: "youtube",
  },
  {
    id: nanoid(),
    entity: "twitter",
  },
  {
    id: nanoid(),
    entity: "linkedin",
  },
  {
    id: nanoid(),
    entity: "pinterest",
  },
];

const Entities = () => {
  const dispatch = useDispatch();
  const entity = useSelector(selectEntity);

  const [search, setSearch] = useState<string>();

  const [filteredEntities, setFilteredEntities] = useState<Entity[]>([]);

  useEffect(() => {
    if (search)
      setFilteredEntities(
        entities.filter((item) =>
          item.entity.toLowerCase().includes(search.toLowerCase())
        )
      );
    else setFilteredEntities([]);
  }, [search]);

  return (
    <>
      <SearchBar placeholder="Data source" onChange={(val) => setSearch(val)} />
      {filteredEntities.length === 0 ? (
        <>
          <View style={styles.main}>
            <Entity
              entity={entities[0].entity}
              size={"large"}
              isOpaque={entity === entities[0].entity}
              onPress={() => dispatch(setEntity(entities[0].entity))}
              style={{ marginRight: 12 }}
              key={nanoid()}
            />
            <Entity
              entity={entities[1].entity}
              size={"large"}
              isOpaque={entity === entities[1].entity}
              onPress={() => dispatch(setEntity(entities[1].entity))}
              style={{ marginLeft: 12 }}
              key={nanoid()}
            />
          </View>
          <Divider style={{ marginVertical: 20 }} />
          <View style={styles.secondary}>
            <View style={{ marginRight: 30 }}>
              {entities
                .slice(2)
                .slice(0, Math.ceil(entities.slice(2).length / 2))
                .map((s) => (
                  <Entity
                    entity={s.entity}
                    size={"small"}
                    isOpaque={entity === s.entity}
                    onPress={() => dispatch(setEntity(s.entity))}
                    style={{ marginBottom: 14 }}
                    key={nanoid()}
                  />
                ))}
            </View>
            <View style={{ marginLeft: 30 }}>
              {entities
                .slice(2)
                .slice(
                  Math.ceil(entities.slice(2).length / 2),
                  entities.slice(2).length
                )
                .map((s) => (
                  <Entity
                    entity={s.entity}
                    size={"small"}
                    isOpaque={entity === s.entity}
                    onPress={() => dispatch(setEntity(s.entity))}
                    style={{ marginBottom: 14 }}
                  />
                ))}
            </View>
          </View>
        </>
      ) : (
        <View style={styles.centered}>
          {filteredEntities.map((s) => (
            <Entity
              entity={s.entity}
              size={"large"}
              isOpaque={entity === s.entity}
              onPress={() => dispatch(setEntity(s.entity))}
              style={{ marginBottom: 14 }}
              key={nanoid()}
            />
          ))}
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  main: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 20,
  },
  divider: {
    height: 1,
    width: "100%",
    backgroundColor: Colors.plum500,
    marginVertical: 20,
  },
  secondary: {
    flexDirection: "row",
    justifyContent: "center",
  },
  centered: {
    marginTop: 10,
    alignItems: "center",
  },
});

export default Entities;
